module.exports = __webpack_public_path__ + "static/sport/gif-h5.0f432db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/gif-h5.gif
// module id = VtfE
// module chunks = 0